import { Component, Input, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { ReportService } from "../../../Report/report.service";
import { DataService_Attendance } from "../shared/data.service";
import * as moment from "moment";

@Component({
	selector: "caass-timescan-info",
	templateUrl: "./timescan-info.component.html",
	styleUrls: ["./timescan-info.component.css"],
})
export class TimescanInfoComponent implements OnInit {
	constructor(private userService: UserService, private AttendanceTempService: DataService_Attendance, private reportService: ReportService) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		if (this.Person != undefined && this.StartDate != undefined && Date.parse(this.StartDate) && this.EndDate != undefined && Date.parse(this.EndDate)) {
			this.loadTimeScan();
		}
	}

	ngOnChanges() {
		if (this.Person != undefined && this.StartDate != undefined && Date.parse(this.StartDate) && this.EndDate != undefined && Date.parse(this.EndDate)) {
			this.loadTimeScan();
		}
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() Person: any;
	@Input() StartDate: any;
	@Input() EndDate: any;

	isProcessing: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedTimeScan: any;
	lstTimeScan: any = [];

	//Filter lists
	lstEntryDayDesc: any = [];
	lstTimeScanTypeDesc: any = [];
	lstScanStation: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "EntryDate", header: "Date" },
		{ field: "EntryDayDesc", header: "Day" },
		{ field: "TimeScanTypeDesc", header: "Type" },
		{ field: "EntryTime", header: "Time" },
		{ field: "ScanStation", header: "ScanStation" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadTimeScan() {
		this.loading = true;

		//Format dates
		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		var result = this.AttendanceTempService.LoadTimeScan(this.Person.PersonID, fsDate, feDate);
		result.subscribe(
			(response) => {
				this.lstTimeScan = response;

				//Update Values
				for (var i = 0; i < this.lstTimeScan.length; i++) {
					var next = this.lstTimeScan[i];

					next.EntryDate = moment(next.EntryDate).format("MM/DD/YYYY");
					next.EntryDayDesc = this.IntToDay(new Date(next.EntryDate).getDay());
					next.EntryTime = moment(next.EntryTime).format("h:mm:ss a");
				}

				//Load Data Filter Lists
				this.lstEntryDayDesc = Array.from(new Set(this.lstTimeScan.map((item: any) => item.EntryDayDesc))).sort();
				this.lstTimeScanTypeDesc = Array.from(new Set(this.lstTimeScan.map((item: any) => item.TimeScanTypeDesc))).sort();
				this.lstScanStation = Array.from(new Set(this.lstTimeScan.map((item: any) => item.ScanStation))).sort();

				this.loading = false;
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadTimeScan();
	}

	//Custom Button Methods
	onPrintTimeScan() {
		this.errorMessage = "";

		//Error handling

		//Call SP
		var component = this;
		this.isProcessing = true;

		this.errorMessage = "";

		var strParam = "";

		//Parameter 1: PersonID
		strParam += this.Person.PersonID + "|PersonID";

		//Parameter 2: StartDate
		strParam += "," + moment(this.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 3: EndDate
		strParam += "," + moment(this.EndDate).format("MM/DD/YYYY") + "|EndDate";

		var reportID = 236;

		//Add file type selector
		var result = this.reportService.Print(reportID, strParam, this.Person.SchoolID, 1);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedTimeScan = val.data;
	}
	onRowUnselect(val) {
		this.SelectedTimeScan = null;
	}
	onRowDblClick(TimeScan) {
		this.SelectedTimeScan = TimeScan;
		this.onPrintTimeScan();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////
	IntToDay(i) {
		if (i == 0) {
			return "Sun";
		} else if (i == 1) {
			return "Mon";
		} else if (i == 2) {
			return "Tue";
		} else if (i == 3) {
			return "Wed";
		} else if (i == 4) {
			return "Thu";
		} else if (i == 5) {
			return "Fri";
		} else if (i == 6) {
			return "Sat";
		}
	}
	////////////////////////////////////////////
}
